import CodeHighlight from "../../../../src/common/CodeHighlight";
import { GettingStartedImportCSS, GettingStartedImportModusReactBootstrap, GettingStartedImportModusIcons } from "../../../../src/examples/getting-started/GettingStarted";
import * as React from 'react';
export default {
  CodeHighlight,
  GettingStartedImportCSS,
  GettingStartedImportModusReactBootstrap,
  GettingStartedImportModusIcons,
  React
};